import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-checkmark",
  "use": "icon-icon-checkmark-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol viewBox=\"0 0 52 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-checkmark\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26ZM14 26.1924L17.5355 22.6569L23.8995 29.0208L35.9204 17L39.4559 20.5355L27.435 32.5564L23.8995 36.0919L23.8995 36.0919L20.364 32.5564L14 26.1924Z\" fill=\"#BFFB4F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol